import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function StudentDashboard() {
  const user = useSelector((state) => state.authState?.user);

  const todayClasses = [
    { id: 1, time: '09:00 AM', subject: 'Mathematics', faculty: 'Mr. Sharma' },
    { id: 2, time: '10:30 AM', subject: 'Science', faculty: 'Mrs. Roy' },
    { id: 3, time: '12:00 PM', subject: 'English', faculty: 'Ms. Das' },
  ];

  const notices = [
    'Submit assignment before 5:00 PM',
    'Unit test starts from next Monday',
    'Library books return by Friday',
  ];

  return (
    <div className='container-fluid py-4'>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <div>
          <h4 className='fw-bold text-dark mb-1'>
            Welcome,{' '}
            <span className='text-primary'>{user?.user_name || 'Student'}</span>
          </h4>
          <p className='text-muted m-0'>Here is your student dashboard</p>
        </div>

        <div>
          <span className='badge bg-light text-dark px-3 py-2 rounded-pill'>
            Student
          </span>
        </div>
      </div>

      <Row className='g-4 mb-4'>
        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-journal-text text-primary'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Classes Today
                </h6>
                <h2 className='fw-bold mb-0'>3</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-check2-square text-success'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Attendance
                </h6>
                <h2 className='fw-bold mb-0'>92%</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-file-earmark-check-fill text-warning'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Assignments Due
                </h6>
                <h2 className='fw-bold mb-0'>2</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-award-fill text-danger'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Exam Score
                </h6>
                <h2 className='fw-bold mb-0'>84%</h2>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className='g-4'>
        <Col lg='8'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <h5 className='fw-bold mb-3'>
              <i className='bi bi-calendar-event text-primary me-2'></i>
              Today Schedule
            </h5>

            <div className='table-responsive'>
              <table className='table align-middle'>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Subject</th>
                    <th>Faculty</th>
                  </tr>
                </thead>
                <tbody>
                  {todayClasses.map((item) => (
                    <tr key={item.id}>
                      <td>{item.time}</td>
                      <td>{item.subject}</td>
                      <td>{item.faculty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>

        <Col lg='4'>
          <div className='card border-0 shadow-sm rounded-4 p-4 mb-4'>
            <h5 className='fw-bold mb-3'>Quick Links</h5>
            <div className='d-grid gap-2'>
              <Link
                to='/student-attendance-view'
                className='btn btn-outline-primary btn-sm'
              >
                View Attendance
              </Link>
              <Link
                to='/assignment-list'
                className='btn btn-outline-success btn-sm'
              >
                My Assignments
              </Link>
              <Link
                to='/student-result'
                className='btn btn-outline-warning btn-sm'
              >
                View Results
              </Link>
            </div>
          </div>

          <div className='card border-0 shadow-sm rounded-4 p-4'>
            <h5 className='fw-bold mb-3'>Notices</h5>
            <ul className='list-group list-group-flush small'>
              {notices.map((item, index) => (
                <li key={index} className='list-group-item px-0'>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
}